<template>
  <div class="bg-gray-500" id="form">
    <div class="form-background container mx-auto p-8 mb-12">
      <form
        @submit.prevent="shortenLink"
        class="flex flex-wrap md:flex-row justify-center"
      >
        <input
          class="w-4/5 mt-8 p-2"
          type="text"
          placeholder="Shorten a link here"
          v-model="url"
          autofocus
        />
        <p class="container text-red-500 ml-0 md:ml-16" v-if="visible">
          Please input a link
        </p>
        <button @click="loading" class="rounded bg-blue-500 ml-2 mt-8 p-3 text-lg text-white">
          Shorten it!
        </button>
      </form>
    </div>
    <div v-if="shorten">
      <ShortenedLink :shorten="shorten" :links="links" />
    </div>
    <div v-show="spinner" class="flex flex-col">
        <p class="text-center text-blue-300">Please wait...</p>
        <img src="../assets/hourglass.gif" class="object-scale-down h-24 w-24 mt-2 mx-auto mb-12" alt="">
    </div>
  </div>
</template>

<script>
import ShortenedLink from "./ShortenedLink";

export default {
  name: "Form",
  components: { ShortenedLink },
  data() {
    return {
      url: "",
      shorten: "",
      links: [
        //{shorten: "", url: ""},
      ],
      visible: false,
      spinner: false,
    };
  },
  methods: {
    async shortenLink() {
      const res = await fetch(
        `https://api.shrtco.de/v2/shorten?url=${this.url}`
      );
      const data = await res.json();
      //console.log(data.result);

      // this.url = "";

      if (!this.url) {
        this.visible = true;
        this.spinner = false; 
      } else {
        this.shorten = data.result.full_short_link;
        this.links.push(
           { url: this.url },
          { shorten: data.result.full_short_link },
         
        );
        this.visible = false;
        this.url = "";
        this.spinner = false
      }
    },
    loading() {
      if(!this.shorten){
        this.spinner= true
      } 
  },
  }
};
</script>

<style scoped>
.form-background {
  max-width: 80%;
  margin-top: 30px;
  background-color: hsl(257, 27%, 26%);
  background-image: url(../assets/images/bg-boost-desktop.svg);
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.back {
  background-color: gray;
  width: 100%;
}
</style>
